<template>
  <div class="app-container">
    <el-tabs type="border-card" @tab-click="clickTab">
      <el-tab-pane label="糖尿病">
        <component :is="currentView1" v-if="update1"></component>
      </el-tab-pane>
      <el-tab-pane label="高血压">
        <component :is="currentView2" v-if="update2"></component>
      </el-tab-pane>
      <el-tab-pane label="高血脂">
        <component :is="currentView3" v-if="update3"></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import bloodFollowUp from './bloodFollowUp.vue';
import bloodPressureFollowUp from './bloodPressureFollowUp.vue';
import bloodFatFollowUp from './bloodFatFollowUp.vue';

export default {
  components: {bloodFollowUp, bloodPressureFollowUp, bloodFatFollowUp},
  props:{
      
  },
  data() {
    return {
      currentView1: "bloodFollowUp",
      currentView2: "bloodPressureFollowUp",
      currentView3: "bloodFatFollowUp",
      update1: true,
      update2: false,
      update3: false
    };
  },
  methods:{
    clickTab(targetName){
      console.log(targetName);
      if(targetName.label == "糖尿病") {
        this.update1 = true;
        this.update2 = false;
        this.update3 = false;
      } else if (targetName.label == "高血压") {
        this.update1 = false;
        this.update2 = true;
        this.update3 = false;
      } else if (targetName.label == "高血脂") {
        this.update1 = false;
        this.update2 = false;
        this.update3 = true;
      }
    }
  }
};
</script>

<style>
</style>
